import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import * as ReactBootstrap from "react-bootstrap";
import { useState, useEffect } from "react";
import Title from '../ReusableComponents/title'
import Add from '../../assets/images/addcase.svg'
import { Grid } from "@mui/material";
import '../../assets/css/SupportCenter.scss'
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import HeadAndDesc from "../ReusableComponents/HeadAndDesc";
import logoutReducer from "../../store/reducers/logout";
import { formatDate } from "../../utilities/formatters";
import useMobile from "../../hooks/useMobile";
import { axiosInstance } from "../../Axios";





const StatFormatter = (data) => {
    const Stat = data && data.toLowerCase()
    const classList =
        Stat === "resolved"
            ? "StatusResolved StatusText"
            : Stat === "dismissed"
                ? "StatusDismissed StatusText"
                : Stat === "in progress"
                    ? "StatusProgress StatusText"
                    : "status"

    return <div className={`${classList}`} style={{width:"unset"}}>{data}</div>
}

const SupportCasestable = (props) => {
    const [Show, setSHow] = useState(false)
    const dispatch = useDispatch();

    const isMobile = useMobile();

    const handleChange = (data) => {
        const { showDetails } = props;
        axiosInstance
            .post(`support/case/history/${data}/`, {
                idToken: ACCtoken,
            })
            .then((res) => {
                console.log('====================================')
                console.log(res)
                console.log('====================================')
                if (res.data === 'No Cases found!') {
                    alert('No Cases found!')
                    return
                }
                if (res.data === 'Please verify the Access Token!') {
                    dispatch(logoutReducer());
                    return
                }
                showDetails(res.data);
                // setCase(res.data.data)
                // setSHow(true)
                // console.log(res.data.data);
            })
            .catch(function (error) {
                console.log(error)
                if (error.response) {
                    //   console.log(error.response.data)
                    //   console.log(error.response.status)
                    //   console.log(error.response.headers)
                }
            })

    }

    const [Data, setData] = useState([])
    const ACCtoken = useSelector((state) => state.ACCtoken)
    useEffect(() => {
        axiosInstance
            .post('support/user/cases/get/', {
                idToken: ACCtoken,
            })
            .then((res) => {
                // console.log("=============================")
                // console.log(res.data.data)
                // console.log("=============================")
                if (res.data === 'No Cases found!') {
                    alert('No Cases found!')
                    return
                }
                if (res.data === 'Please verify the Access Token!') {
                    dispatch(logoutReducer());
                    return
                }
                setData(res.data.data)
                console.log(Data);
            })
            .catch(function (error) {
                console.log(error)
                if (error.response) {
                }
            })

    }, [])


    const { handleAdd } = props;
    return (
        <div>
            <Grid onClick={() => handleAdd()} className="createcase" container justifyContent="end" alignItems="center">
                <img src={Add} alt=''/>
                <Title four>Create case</Title>
            </Grid>
            {!Show && <div className="TableContainer">
                {!isMobile &&<ReactBootstrap.Table bordered="true" className="CasesDesk">
                    <thead>
                        <tr className="d-flex">
                            <th>Subject</th>
                            <th>Created</th>
                            <th>CaseID</th>
                            <th>Casetype</th>
                            <th>Severity</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody >

                        {
                            Object.keys(Data).map((data, index) => {
                                return (
                                    <tr className="d-flex" key={index}>
                                        <td onClick={() => handleChange(Data[data].id)}>{Data[data].subject}</td>
                                        <td onClick={() => handleChange(Data[data].id)}>{formatDate(Data[data].created)}</td>
                                        <td className="CaseIDBox" onClick={() => handleChange(Data[data].id)}>{Data[data].id}</td>
                                        <td onClick={() => handleChange(Data[data].id)}>{Data[data].Case_Type}</td>
                                        <td onClick={() => handleChange(Data[data].id)}>{Data[data].severity}</td>
                                        <td onClick={() => handleChange(Data[data].id)}>{StatFormatter(Data[data].status)}</td>
                                    </tr>
                                )
                            })
                        }

                    </tbody>
                </ReactBootstrap.Table>}




                {isMobile && <div className="CasesMobile">

                    {
                        Object.keys(Data).map((data, index) => {
                            return (

                                <div>

                                    <div className="CasesBox">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div>
                                                <HeadAndDesc
                                                    HeadTitle="Subject"
                                                    SubTitle={Data[data].subject}
                                                />
                                            </div>
                                            <div>{StatFormatter(Data[data].status)}</div>
                                        </div>
                                        <div>
                                            <div className="text-align-left d-flex mbb-10 gapp-20">
                                                <div className="d-flex gapp-5 CasesText">
                                                    <Title three>Case ID: </Title>
                                                    <Title StyleName="CaseID" four><span onClick={() => handleChange(Data[data].id)}>{Data[data].id}</span></Title>
                                                </div>
                                                <div className="d-flex gapp-5 CasesText">
                                                    <Title three>Case type : </Title>
                                                    <Title four>{Data[data].Case_Type}</Title>
                                                </div>
                                            </div>
                                            <div className="d-flex gapp-5 CasesText">
                                                <Title three>Date : </Title>
                                                <Title four>{Data[data].created && formatDate(new Date(Data[data].created))}</Title>
                                            </div>
                                        </div>
                                    </div>



                                    {/* <CasesBox
                                        Subject={Data[data].subject}
                                        Status={StatFormatter(Data[data].status)}
                                        CaseID={Data[data].id}
                                        Type={Data[data].Case_Type}
                                        Date={Data[data].created}
                                        onClick={() => handleChange(Data[data].id)}
                                    /> */}
                                </div>
                            )
                        })
                    }

                </div>}
            </div>}

        </div>
    );
}

export default SupportCasestable